import React from 'react';
import { Box } from '@mui/material';
import Navigation from '../Navigation/Navigation';
import AppBar from '../AppBar/AppBar';
import PropTypes from 'prop-types';

/**
 * AuthenticatedLayout Component
 * Layout wrapper for authenticated routes with navigation and app bar
 */
const AuthenticatedLayout = ({
  children,
  navigationOpen,
  onToggleNavigation,
}) => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Navigation open={navigationOpen} onToggle={onToggleNavigation} />
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <AppBar />
        <Box sx={{ flexGrow: 1, overflow: 'auto' }}>{children}</Box>
      </Box>
    </Box>
  );
};

AuthenticatedLayout.propTypes = {
  children: PropTypes.node.isRequired,
  navigationOpen: PropTypes.bool.isRequired,
  onToggleNavigation: PropTypes.func.isRequired,
};

export default AuthenticatedLayout;
